import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MAX_INT32_VAL } from 'src/app/constants';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-rabat-form',
    templateUrl: './rabat-form.component.html',
    styleUrls: ['./rabat-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RabatFormComponent implements OnInit, OnDestroy {
  @Input() rabatForm: UntypedFormGroup;
  @Input() isPrivatKunde: boolean;
  @Input() maxKontantRabat: number = MAX_INT32_VAL;
  tabIndex = 0;
  rabatPeriodsuffix = 'årlig';

  unsubscribe$ = new Subject<void>();

  get rabatKontant() {
    return this.rabatForm.get('rabatKontant');
  }

  get rabatProcent() {
    return this.rabatForm.get('rabatProcent');
  }

  get rabatTekst() {
    return this.rabatForm.get('rabatTekst');
  }

  get rabatSplit() {
    return this.rabatForm.get('rabatSplit');
  }

  get engangsRabat() {
    return this.rabatForm.get('engangsRabat');
  }

  constructor() {
  }

  ngOnInit(): void {
    if (this.rabatKontant.value) {
      this.tabIndex = 1;
    }

    this.rabatPeriodsuffix = this.engangsRabat.value === true ? 'engangs' : 'årlig';

    this.engangsRabat.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      this.rabatPeriodsuffix = val === true ? 'engangs' : 'årlig';
    });

    this.rabatForm.get('rabatKontant').valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      if (val != undefined && this.tabIndex !== 1) {
        this.tabIndex = 1;
        this.updateValidityForTab(1);
      }
    });

    this.rabatForm.get('rabatProcent').valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      if (val != undefined && this.tabIndex !== 0) {
        this.tabIndex = 0;
        this.updateValidityForTab(0);
      }
    });

    this.updateValidityForTab(this.tabIndex);

    this.rabatSplit.setValidators([Validators.required]);
    this.rabatSplit.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  tabChanged(change: MatTabChangeEvent) {
    this.tabIndex = change.index;
    this.updateValidityForTab(change.index);
  }

  private updateValidityForTab(tabIndex: number) {
    if (tabIndex === 0 /*Procent*/) {
      this.rabatKontant.clearValidators();
      this.rabatKontant.setValue(null);
      this.rabatProcent.setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
    } else if (tabIndex === 1 /*Kr/øre*/) {
      this.rabatProcent.clearValidators();
      this.rabatProcent.setValue(null);
      this.rabatKontant.setValidators([Validators.required, Validators.min(1), Validators.max(this.maxKontantRabat)]);
    }
    this.rabatKontant.updateValueAndValidity();
    this.rabatProcent.updateValueAndValidity();
  }
}
